/* eslint-disable use-isnan */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Translate from '../../../i18n/Translate';
import api from '../../../services/Api';
import SpinnerEllipsis from '../../../components/loaders/SpinnerEllipsis';

const Prices = () => {
  const [prices, setPrices] = useState({
    isLoading: true,
    status: null,
    error: null,
    date: null,
    prices: null,
  });
  const { t } = useTranslation();

  useEffect(() => {
    const fetchData = async () => {
      setPrices({ isLoading: true, error: null });

      try {
        const data = await api.prices.get();

        if (data.status) {
          setPrices({
            isLoading: false,
            status: data.status,
            error: false,
            date: data.date,
            results: data.result,
          });
        }
      } catch (error) {
        console.log(error);
        setPrices({ loading: false, error });
      }
    };
    fetchData();
  }, []);

  if (prices.error) {
    return null;
  }
  if (prices.isLoading) {
    return <SpinnerEllipsis color='secundario' />;
  }
  const formattedDate = new Intl.DateTimeFormat('en-GB').format(new Date()); // ==> 18/02/2022; sino es-AR da 18/2/2022

  if (prices.status) {
    return (
      <div className='header__content__links__prices'>
        <p>
          <Translate langkey='header.prices.part1' />
          &ensp;
          <span className='price'>{formattedDate}</span>&nbsp; / &nbsp;
        </p>
        {prices.results.map((item, index) => {
          return (
            <p key={index}>
              <Translate langkey='header.prices.part2' />{' '}
              <span className='price'>{item.USD}</span>
              &nbsp; / &nbsp;
              <Translate langkey='header.prices.part3' />{' '}
              <span className='price'>{item.BSP}</span>
            </p>
          );
        })}
      </div>
    );
  }
};

export default Prices;
